module.exports = __webpack_public_path__ + "static/media/greenpeg_logo 1.87029a1d.svg";